@if (showWebshopTabs()) {
  <order-tabs (changeOrderEvent)="onChangeOrderEvent()"></order-tabs>
}

@if (showMyTabs()) {
  <ul class="header-tabs hide-sm">
    <li
      [ngClass]="{
        active: isOnPendingOrders(),
        'theme-primary-highlight-color': true
      }"
      >
      <a
        [routerLink]="['/my/pending/orders']"
        i18n="Navigation: Pending orders@@navigation.pending.orders"
        >Pending orders</a
        >
      </li>
      <li
      [ngClass]="{
        active: isOnOrderHistory(),
        'theme-primary-highlight-color': true
      }"
        >
        <a
          [routerLink]="['/my/order/history']"
          i18n="Navigation: Order history@@navigation.order.history"
          >Order history</a
          >
        </li>
        <li
      [ngClass]="{
        active: isOnPricelists(),
        'theme-primary-highlight-color': true
      }"
          >
          <a
            [routerLink]="['/my/pricelists']"
            i18n="Navigation: Pricelists@@navigation.pricelists"
            >Pricelists</a
            >
          </li>
          <li
      [ngClass]="{
        active: isOnFavorites(),
        'theme-primary-highlight-color': true
      }"
            >
            <a
              [queryParams]="{ mode: 'all', features: 'ISFAVO', clear: true }"
              [routerLink]="['/products']"
              i18n="Navigation: Favorites@@navigation.favorites"
              >Favorites</a
              >
            </li>
            @if (allowClaims()) {
              <li
      [ngClass]="{
        active: isOnClaims(),
        'theme-primary-highlight-color': true
      }"
                >
                <a
                  [routerLink]="['/my/claims']"
                  i18n="Navigation: Claims@@navigation.claims"
                  >Claims</a
                  >
                </li>
              }
              <li>
                <a
                  (click)="logout()"
                  class="theme-primary-highlight-color"
                  href="#"
                  i18n="Navigation: Log out@@navigation.log.out"
                  >Log out</a
                  >
                </li>
              </ul>
              <!-- Responsive navigation -->
              <div class="custom-select header-tabs--select hide-lg hide-md visible-sm">
                <select (change)="navigate($event)">
                  <option
                    [selected]="isOnPendingOrders()"
                    i18n="Navigation: Pending orders@@navigation.pending.orders"
                    value="/my/pending/orders"
                    >
        Pending orders
      </option>
                  <option
                    [selected]="isOnOrderHistory()"
                    i18n="Navigation: Order history@@navigation.order.history"
                    value="/my/order/history"
                    >
        Order history
      </option>
                  <option
                    [selected]="isOnPricelists()"
                    i18n="Navigation: Pricelists@@navigation.pricelists"
                    value="/my/pricelists"
                    >
        Pricelists
      </option>
                  <option
                    [selected]="isOnFavorites()"
                    i18n="Navigation: Favorites@@navigation.favorites"
                    value="/my/favorites"
                    >
        Favorites
      </option>
                  @if (allowClaims()) {
                    <option
                      [selected]="isOnClaims()"
                      i18n="Navigation: Claims@@navigation.claims"
                      value="/my/claims"
                      >
        Claims
      </option>
                  }
                  <option i18n="Navigation: Log out@@navigation.log.out" value="/login">
        Log out
      </option>
                </select>
              </div>
            }
